import NavBar from "../components/NavBar";
import Hero from "../components/courses/Hero";
import Content from "../components/courses/Content";
import Footer from "../components/Footer";

function Courses() {
  return (
    <div className="  ">
      <NavBar />
      <Hero />
      <Content />
      <Footer />
    </div>
  );
}

export default Courses;
